import { useState } from 'react';
import {useMessage} from "../Componentes/Message";

export const UrlReporte = {
  SALDO_ANTIGUEDAD_CXC: "/CxC/WebService/CxcWebService.asmx/ImprimirSaldoAntiguedad",
  ESTADO_CUENTA_CXC: "/CxC/WebService/CxcWebService.asmx/ImprimirEstadoCuenta",
  SALDO_ANTIGUEDAD_CXP: "/CxP/WebService/CxpWebService.asmx/ImprimirSaldoAntiguedad",
  ESTADO_CUENTA_CXP: "/CxP/WebService/CxpWebService.asmx/ImprimirEstadoCuenta",
  ESTADO_RESULTADO: "/Contabilidad/WebService/ContabilidadWebService.asmx/ImprimirEstadoResultado",
  MAYOR_GENERAL: "/Contabilidad/WebService/ContabilidadWebService.asmx/ImprimirMayorGeneral",
  BALANCE_GENERAL: "/Contabilidad/WebService/ContabilidadWebService.asmx/ImprimirBalanceGeneral",
  BALANCE_COMPROBACION: "/Contabilidad/WebService/ContabilidadWebService.asmx/ImprimirBalanceComprobacion",
  REPORTE_606: "/Impuesto/WebService/ImpuestoWebService.asmx/ImprimirReporte606",
  REPORTE_607: "/Impuesto/WebService/ImpuestoWebService.asmx/ImprimirReporte607",
};

export const useImprimir = (url, formato) => {
  if (!hfReporteBase64 || !hfFormato) {
    throw new Error("hfReporteBase64 y hfFormato deben estar definidos");
  }
  const { handleException, handleOk, clearMessages } = useMessage();

  const [loading, setLoading] = useState(false);

  const imprimirReporte = (url, parametros, formato = "PDF") => {
    return new Promise(function (resolve, reject) {
      const where = { where: { ...parametros, FormatoReporte: formato } };
      Citrus.AJAX.getJSON(url, where, function (respuesta) {
        var datos = $.parseJSON(respuesta.d);

        if (
          datos &&
          datos["Mensaje"] !== undefined &&
          datos["Detalle"] !== undefined &&
          datos["Interno"] !== undefined
        ) {
          reject(datos);
        }
        resolve(datos);
      });
    });
  };

  const handleImprimir = (parametros) => {
    clearMessages();
    setLoading(true);

    imprimirReporte(
      url,
      {
        ...parametros,
      },
      formato
    )
      .then((res) => {
        hfReporteBase64.val(res?.Resultado);
        hfFormato.val(res?.Formato);

        let base64 = hfReporteBase64.val();
        let formato = hfFormato.val();

        console.log(hfClienteId);

        Citrus.Utils.imprimirReporte(base64, formato, hfClienteId);
        handleOk("Exportado con exito.", 5);
      })
      .catch((err) => {
        console.log("imprimir", err);
        handleException(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return [loading, handleImprimir];
};

/* Codigo necesario en el User Control */
/*
  <asp:HiddenField ID="hfReporteBase64" runat="server"/>
  <asp:HiddenField ID="hfFormato" runat="server"/>

  <script>
      let hfReporteBase64 = $('#<%= hfReporteBase64.ClientID%>');
      let hfFormato = $('#<%= hfFormato.ClientID%>');
      let hfClienteId = '<%=hfReporteBase64.ClientID%>'
  </script>
*/
